import { useEffect, useState } from 'react';
import { CloudSlash, ArrowsClockwise } from '@phosphor-icons/react';

export default function OfflineIndicator() {
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(0);
  const [syncing, setSyncing] = useState(false);

  useEffect(() => {
    const onOnline = () => setOnline(true);
    const onOffline = () => setOnline(false);
    const onQueue = (e) => { setPending(e.detail.pending); setSyncing(e.detail.syncing); };
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    window.addEventListener('offline-queue-changed', onQueue);
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
      window.removeEventListener('offline-queue-changed', onQueue);
    };
  }, []);

  if (online && pending === 0 && !syncing) return null;

  return (
    <div data-testid="offline-indicator"
      className="fixed top-2 left-1/2 -translate-x-1/2 z-50 flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-muted text-muted-foreground border shadow-sm">
      {!online ? (
        <><CloudSlash size={14} /> Offline{pending > 0 ? ` · ${pending} pending` : ''}</>
      ) : syncing ? (
        <><ArrowsClockwise size={14} className="animate-spin" /> Syncing…</>
      ) : (
        <><ArrowsClockwise size={14} /> {pending} pending</>
      )}
    </div>
  );
}
